import * as React from 'react';
import { Sidebar } from 'react-admin';

const LamsSidebar = props => {
    return (
        <div></div>
    )
};
export default LamsSidebar